<template>
  <div class="bg-black h-screen">
    <ins-header :title="headerTitle" @back="goBack"></ins-header>
    <div
      class="transac-amount"
      style="margin-top: -26px"
      v-html="model.amount"
    ></div>
    <p class="color-w">ریال</p>
    <div
      class="overflow-hidden flex items-center justify-center trans-card dir-rtl"
    >
      <div style="width: 88%">
        <div class="from">
          <div class="source">
            <p>از</p>
            <img :src="bankAvatar" />
            <select v-model="source_account_id">
              <option
                v-for="account in accountList"
                :key="account.id"
                :value="account.id"
                @change="BankAvataChenger(account)"
              >
                {{ account.name }}
              </option>
            </select>
          </div>
          <div class="dest">
            <p>به</p>
            <p>~ {{ this.setDistinationUser.keyword }}</p>
          </div>
        </div>
        <div class="about">
          <input
            v-model="model.description"
            :disabled="distinationControl"
            placeholder="انتقال بابت ..."
          />
          <p style="margin-top: 10px; margin-bottom: 10px">
            برای اضافه کردن یاداشت شخصی به این تراکنش علامت زیر را لمس کنید.
          </p>
          <div class="traansaction-plus" @click="distinationControlHandler">
            +
          </div>
          <button
            style="margin-top: 12%; margin-bottom: 15%"
            class="m-btn"
            @click="transActionHandler"
          >
            تایید
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  props: {
    data: [],
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
    bgPic() {
      var address = "../../assets/icon/bg-1.png";
      return address;
    },
  },
  data() {
    return {
      bankAvatar: null,
      model: {
        destinations: [
          {
            destination_id: undefined,
            keyword: null,
          },
        ],
      },
      setDistinationUser: {},
      distinationControl: true,
      accountList: [],
      source_account_id: null,
      ourceAccount: {},
    };
  },
  beforeMount() {
    this.getAccounts();
    if (this.$store.state.transaction.amount == null) {
      this.$router.push({ name: "Home" });
    }
    this.model.amount = this.$store.state.transaction.amount;
    if (this.$store.state.transaction.description != null) {
      this.model.description = this.$store.state.transaction.description;
    }
    this.setDistinationUser = this.$store.state.transaction.distinationUser;
    this.model.destinations[0].destination_id =
      this.setDistinationUser.destination_id;
    this.model.destinations[0].keyword = this.setDistinationUser.keyword;
  },
  methods: {
    BankAvataChenger(account) {
      this.bankAvatar = "https://media-dev.bfst.ir/" + account.bank.avatar;
      this.sourceAccountDataSeter(account);
    },
    distinationControlHandler() {
      this.distinationControl = false;
    },
    sourceAccountDataSeter(account) {
      this.sourceAccount = account;
    },
    getAccounts() {
      this.$store.dispatch("accounts/getList").then((rsp) => {
        this.accountList = rsp;
        for (let index = 0; index < rsp.length; index++) {
          if (rsp[index].is_default) {
            this.source_account_id = rsp[index].id;
            this.BankAvataChenger(rsp[index]);
          }
        }
      });
    },
    goBack() {
      this.$router.back();
    },
    transActionHandler() {
      this.model.source_account_id = this.source_account_id;
      this.$store.dispatch("transaction/creat", this.model).then((respons) => {
        this.$store.commit("transaction/setTransaction", respons[0]);
        this.$store.commit("transaction/setSourceAccount", this.sourceAccount);
        this.$router.push({ name: "Success" });
      });
    },
  },
  components: {
    InsHeader,
  },
};
</script>
